import React from "react";
import { LoaderPoint } from "./PointersLine.styled";
const PointersLine = ({ color, width, left, top, moodMeter }) => {
  return (
    <LoaderPoint color={color} width={width} top={top} left={left}>
      {moodMeter ? (
        <>
          <div></div>
          <div></div>
          <div></div>
        </>
      ) : (
        <>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </>
      )}
    </LoaderPoint>
  );
};
export default PointersLine;
